module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-e7f20fcb.png";